<footer class="weFooter">
	<!-- Würth Elektronik Brand section that overlaps the top of the footer -->
	<div class="weFooter__brand">
		<div class="weFooter__brandContainer">
			<a aria-label="Würth Elektronik Logo" class="weFooter__brandLogo" href="/">
				<app-icon class="weFooter__brandLogoSvg" name="logo-48" title="Würth Elektronik Logo" [size]="76" />
			</a>
		</div>
	</div>

	<!-- Main footer content with padding-top to accommodate the overlapping brand -->
	<div class="weFooter__main">
		<div class="weContainer">
			<div class="weFooter__content">
				<ul class="weFooter__social">
					<li class="weFooter__socialItem">
						<a
							aria-label="Würth Elektronik Facebook"
							class="weFooter__socialLink"
							href="https://www.we-online.com/facebook-we-group"
							rel="noopener noreferrer"
							target="_blank">
							<app-icon
								aria-hidden="false"
								class="weFooter__socialIcon"
								name="socialFacebook"
								title="Würth Elektronik Facebook"
								[size]="24" />
						</a>
					</li>
					<li class="weFooter__socialItem">
						<a
							aria-label="Würth Elektronik Twitter"
							class="weFooter__socialLink"
							href="https://www.we-online.com/twitter"
							rel="noopener noreferrer"
							target="_blank">
							<app-icon
								aria-hidden="false"
								class="weFooter__socialIcon"
								name="socialTwitter"
								title="Würth Elektronik Twitter"
								[size]="24" />
						</a>
					</li>
					<li class="weFooter__socialItem">
						<a
							aria-label="Würth Elektronik LinkedIn"
							class="weFooter__socialLink"
							href="https://www.we-online.com/linkedin"
							rel="noopener noreferrer"
							target="_blank">
							<app-icon
								aria-hidden="false"
								class="weFooter__socialIcon"
								name="socialLinkedIn"
								title="Würth Elektronik LinkedIn"
								[size]="24" />
						</a>
					</li>
					<li class="weFooter__socialItem">
						<a
							aria-label="Würth Elektronik YouTube"
							class="weFooter__socialLink"
							href="https://www.we-online.com/youtube"
							rel="noopener noreferrer"
							target="_blank">
							<app-icon
								aria-hidden="false"
								class="weFooter__socialIcon"
								name="socialYouTube"
								title="Würth Elektronik YouTube"
								[size]="24" />
						</a>
					</li>
					<li class="weFooter__socialItem">
						<a
							aria-label="Würth Elektronik Instagram"
							class="weFooter__socialLink"
							href="https://www.we-online.com/instagram-we-group"
							rel="noopener noreferrer"
							target="_blank">
							<app-icon
								aria-hidden="false"
								class="weFooter__socialIcon"
								name="socialInstagram"
								title="Würth Elektronik Instagram"
								[size]="24" />
						</a>
					</li>
					<li class="weFooter__socialItem">
						<a
							aria-label="Würth Elektronik TikTok"
							class="weFooter__socialLink"
							href="https://www.we-online.com/tiktok"
							rel="noopener noreferrer"
							target="_blank">
							<app-icon
								aria-hidden="false"
								class="weFooter__socialIcon"
								name="socialTikTok"
								title="Würth Elektronik TikTok"
								[size]="24" />
						</a>
					</li>
				</ul>

				<div class="weFooter__access">
					{{ 'FOOTER.ACCESSIBILITY' | translate }}
				</div>

				<div class="weFooter__bottom">
					<div class="weFooter__legal">
						<a
							class="weFooter__legalLink"
							href="//www.we-online.com/contact"
							rel="noopener noreferrer"
							target="_blank"
							>{{ 'FOOTER.CONTACT' | translate }}</a
						>
						<a
							class="weFooter__legalLink"
							href="//www.we-online.com/imprint"
							rel="noopener noreferrer"
							target="_blank"
							>{{ 'FOOTER.IMPRINT' | translate }}</a
						>
						<a
							class="weFooter__legalLink"
							href="//www.we-online.com/privacy"
							rel="noopener noreferrer"
							target="_blank"
							>{{ 'FOOTER.PRIVACY' | translate }}</a
						>
					</div>
					<div class="weFooter__copyright">
						{{ 'FOOTER.COPYRIGHT' | translate: { year: currentYear } }}
						<dl
							class="weUtilsFlyout weFooter__languageFlyout"
							tabindex="0"
							[class.weUtilsFlyout--open]="isFooterLanguageMenuOpen">
							<dt class="weUtilsFlyout__label">
								<button class="weFooter__languageToggle" (click)="toggleFooterLanguageMenu(); $event.stopPropagation()">
									<span class="weFooter__languageLabel weFooter__languageLabel--arrow">{{
										i18nService.getCurrentLanguageLong()
									}}</span>
								</button>
							</dt>
							<dd class="weUtilsFlyout__panel weUtilsFlyout__panel--top">
								<ul class="weFooter__languageMenu">
									<li class="weFooter__languageMenuItem">
										<a
											class="weFooter__languageMenuLink"
											hreflang="en"
											lang="en"
											role="button"
											tabindex="0"
											[class.weFooter__languageMenuLink--active]="translateService.currentLang === 'en'"
											(click)="switchLanguage('en'); toggleFooterLanguageMenu(); $event.stopPropagation()"
											(keydown.enter)="switchLanguage('en'); toggleFooterLanguageMenu(); $event.stopPropagation()"
											(keydown.space)="
												$event.preventDefault();
												$event.stopPropagation();
												switchLanguage('en');
												toggleFooterLanguageMenu()
											"
											>English</a
										>
									</li>
									<li class="weFooter__languageMenuItem">
										<a
											class="weFooter__languageMenuLink"
											hreflang="de"
											lang="de"
											role="button"
											tabindex="0"
											[class.weFooter__languageMenuLink--active]="translateService.currentLang === 'de'"
											(click)="switchLanguage('de'); toggleFooterLanguageMenu(); $event.stopPropagation()"
											(keydown.enter)="switchLanguage('de'); toggleFooterLanguageMenu(); $event.stopPropagation()"
											(keydown.space)="
												$event.preventDefault();
												$event.stopPropagation();
												switchLanguage('de');
												toggleFooterLanguageMenu()
											"
											>Deutsch</a
										>
									</li>
								</ul>
								<div class="weUtilsFlyout__panelHandle weUtilsFlyout__panelHandle--bottom15"></div>
							</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>
